export enum ThemesEnum {
  default = 'default',
  promo = 'promo-1',
  promo2 = 'promo-2',
  extra = 'extra',
  stars = 'stars',
  light = 'light',
  veryLight = 'very-light',
  dark = 'dark',
  invert = 'invert',
  colored = 'colored',
  regular = 'regular',
  promo_1 = 'promo1',
  promo_2 = 'promo2',
  white = 'white',
  success = 'success',
  lightSuccess = 'light-success',
  activeSuccess = 'active-success',
  pending = 'pending'
}

export enum BrandThemesEnum {
  brand = 'brand',
  brandLight = 'brand-light',
  brandBase = 'brand-base',
  brandDark = 'brand-dark'
}
